module.exports = __webpack_public_path__ + "static/media/power-peak-alert.2ab9eac5.svg";